import React from 'react';

function LoadingScreen() {
  return (
    <p>Loading...</p>
  );
}

export default LoadingScreen;
